import { Trans } from "@lingui/react";
import { formatDateTime } from "@mobility-item-page/utilities";
import { ElementType, Intent, TargetType } from "@mobility-item-page/utilities/client";
import { useAdViewAd, useAdViewMeta } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import usePulse from "../../utils/pulse-tracking/usePulse.ts";
import { ShareButton } from "./sharing/ShareButton.tsx";

const AdReport = () => {
  const { adId, edited } = useAdViewMeta();
  const ad = useAdViewAd();
  const advertiser_ref = "advertiser_ref" in ad ? ad.advertiser_ref : undefined;
  const { locale } = useAppConfig();
  const formattedDate = formatDateTime(edited, locale);
  const { trackClick } = usePulse();

  return (
    <div className="mt-40">
      <h2 className="sr-only">
        <Trans id="itemPageLayout.adReport.screenReader.title" message="Ad information" />
      </h2>
      <div className="text-m flex md:flex-row flex-col md:gap-x-56 gap-y-16">
        <div>
          <p className="s-text-subtle mb-0">
            <Trans id="itemPageLayout.adReport.adId.text" message="Ad id" />
          </p>
          <p className="font-bold whitespace-nowrap mb-0 md:mt-8">{adId}</p>
        </div>

        {formattedDate && (
          <div>
            <p className="s-text-subtle mb-0">
              <Trans id="itemPageLayout.adReport.updated.text" message="Updated" />
            </p>
            <p className="font-bold whitespace-nowrap mb-0 md:mt-8" suppressHydrationWarning>
              {formattedDate}
            </p>
          </div>
        )}

        {advertiser_ref && (
          <div>
            <p className="s-text-subtle mb-0">
              <Trans id="itemPageLayout.adReport.advertiserReference.text" message="Reference" />
            </p>
            <p className="font-bold mb-0 md:mt-8">{advertiser_ref}</p>
          </div>
        )}
      </div>

      <div className="text-m flex flex-row gap-x-28 md:flex-row mt-16 md:mt-24">
        <ShareButton variant="link" />
        <p className="mb-0">
          <a
            rel="nofollow"
            href={`/report/ad?adId=${adId}`}
            data-controller="trackReportAdClick"
            onClick={() =>
              // Tracking event: CE_ev11
              trackClick({
                name: "Report ad",
                objectId: "CE_ev11",
                elementType: ElementType.Link,
                intent: Intent.Report,
                target: {
                  id: "report-ad-link",
                  name: "Report Ad",
                  type: TargetType.Form,
                },
              })
            }
          >
            <Trans id="itemPageLayout.adReport.reportAd.link" message="Report ad" />
          </a>
        </p>
      </div>
    </div>
  );
};

export default AdReport;
